<form [formGroup]="configurationGroup" (ngSubmit)="onSubmit()" [ngClass]="{'view-mode': mode=='View'}">
    <div class="title-outer" [hidden]="loading">
        <h2 class="form-title" *ngIf="mode=='New'">{{
            languageService.languageJSON.ConfigurationDetails_CreateConfigurationView }}</h2>
        <h2 class="form-title" *ngIf="mode=='Edit'">{{
            languageService.languageJSON.ConfigurationDetails_EditConfiguration }}</h2>
        <h2 class="form-title" *ngIf="mode=='View'">{{
            languageService.languageJSON.ConfigurationDetails_ViewConfiguration }}</h2>
    </div>

    <app-loading-animation class="edit-animation" *ngIf="loading"></app-loading-animation>

    <div class="form-section-function"
        [hidden]="!configurationModifyRole || loading || (mode!='View' && mode!='Edit' )">
        <div class="flex-col">
            <div class="flex-row">
                <div class=" row-to-right" *ngIf="mode!='Edit'">
                    <button class="button-with-icon" type="button" (click)="editConfiguration()"><img
                            src="assets/icons/edit.svg" /> {{
                        languageService.languageJSON.Global_Edit }}</button>
                    <button class="button-with-icon" type="button" (click)="deleteConfiguration()"
                        [ngClass]="{inactive: configurationBikeCount}"><img src="assets/icons/delete.svg" /> {{
                        languageService.languageJSON.Global_Delete }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row" *ngIf="configurationId!=-1">
                    <label>{{ languageService.languageJSON.ConfigurationList_ConfigId }}:</label>
                    <label>{{ configurationId }}</label>
                </div>

                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_ConfigName }}:</label>
                    <label *ngIf="mode=='View'">{{configName?.value}}</label>
                    <input *ngIf="mode!='View'" type="text" required formControlName="configName"
                        [ngClass]="{inactive: configurationBikeCount}" (keyup)="onConfigNameKeyPressed()">
                </div>

                <div class="flex-row" *ngIf="configName?.invalid && configName?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_ConfigName }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                        {{ languageService.languageJSON.Form_Length_Error.replace("$X",
                        settingsService.getTitleMaxLength()) }}
                    </h5>
                </div>

                <div class="flex-row" *ngIf="configNameError">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_ConfigNameError }}
                    </h5>
                </div>

                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_Comment }}:</label>
                    <label *ngIf="mode=='View'">{{comment?.value}}</label>
                    <textarea *ngIf="mode!='View'" formControlName="comment"></textarea>
                </div>

                <div class="flex-row" *ngIf="comment?.invalid && comment?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.Form_Length_Error.replace("$X",
                        settingsService.getTitleMaxLength()) }}
                    </h5>
                </div>

                <div class="flex-row" *ngIf="mode!='New'">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_CreationDate }}:</label>
                    <label>{{ creationDate | date:'long' }}</label>
                </div>


                <div class="flex-row" *ngIf="mode!='New'">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_CreatedBy }}:</label>
                    <label>{{ createdBy }}</label>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_OE }}:</label>
                    <mat-select required *ngIf="oeOptionsList" formControlName="oe"
                        (selectionChange)="onOEMChanged(); sameConfigChanged();"
                        [ngClass]="{inactive: configurationBikeCount}">
                        <mat-option *ngFor="let oe of oeOptionsList" [value]="oe.id">{{ oe.name }}</mat-option>
                    </mat-select>
                </div>

                <div class="flex-row" [hidden]="oe?.value==''" *ngIf="oe?.invalid && oe?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_OE }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row" [hidden]="oe?.value==''">
                    <label required>{{ languageService.languageJSON.Global_BikeBrand }}:</label>
                    <mat-select required *ngIf="filteredBrandList && filteredBrandList.length!=0"
                        (selectionChange)="sameConfigChanged()" formControlName="brand"
                        [ngClass]="{inactive: configurationBikeCount}">
                        <mat-option *ngFor="let brand of filteredBrandList" [value]="brand.id">{{ brand.name }}
                        </mat-option>
                    </mat-select>
                    <label *ngIf="filteredBrandList.length==0">{{
                        languageService.languageJSON.ConfigurationDetails_NoOption }}</label>
                </div>

                <div class="flex-row" *ngIf="brand?.invalid && brand?.touched" [hidden]="oe?.value==''">
                    <h5 class="error">
                        {{ languageService.languageJSON.Global_BikeBrand }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row" [hidden]="oe?.value==''">
                    <label required>{{ languageService.languageJSON.ComponentDetails_BikeType }}:</label>
                    <mat-select required *ngIf="bikeTypeOptionsList" formControlName="bikeType"
                        [ngClass]="{inactive: configurationBikeCount}" (selectionChange)="sameConfigChanged()">
                        <mat-option *ngFor="let bikeType of bikeTypeOptionsList" [value]="bikeType.id" selected>{{
                            bikeType.name }}</mat-option>
                    </mat-select>
                </div>

                <div class="flex-row" [hidden]="oe?.value==''" *ngIf="bikeType?.invalid && bikeType?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ComponentDetails_BikeType }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row" [hidden]="oe?.value==''">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_BikeModel }}:</label>
                    <label *ngIf="mode=='View'">{{ bikeModelName?.value }}</label>
                    <input *ngIf="mode!='View'" type="text" required formControlName="bikeModelName"
                        [ngClass]="{inactive: configurationBikeCount}">
                </div>

                <div class="flex-row" [hidden]="oe?.value==''" *ngIf="bikeModelName?.invalid && bikeModelName?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_BikeModel }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                        {{ languageService.languageJSON.Form_Length_Error.replace("$X",
                        settingsService.getTitleMaxLength()) }}
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="mode!='New'">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.Global_Bikes }}:
                        <a (click)="viewBikes()" *ngIf="configurationBikeCount>0">{{ configurationBikeCount + " " +
                            languageService.languageJSON.Global_Bikes }}</a>
                        <span *ngIf="configurationBikeCount==0">{{ configurationBikeCount + " " +
                            languageService.languageJSON.Global_Bikes }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading || oe?.value==''">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label><b>{{ languageService.languageJSON.ConfigurationDetails_BikeComponents }}</b></label>
                    <label></label>
                </div>
                <div class="flex-row  double-selector-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_HMI }}:</label>
                    <div class="double-selector">
                        <label class="extended-label">{{ coreHMIAurix?.value.ComponentName }}</label>
                        <mat-select required
                            *ngIf="coreHMIAurix?.value.Variants && coreHMIAurix?.value.Variants.length!=0"
                            formControlName="coreHMIAurixVariant" [ngClass]="{inactive: configurationBikeCount}"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of coreHMIAurix?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="flex-row" *ngIf="coreHMIAurixVariant?.invalid && coreHMIAurixVariant?.touched">
                    <h5 class="error">
                        {{ coreHMIAurix?.value.ComponentName }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row double-selector-row">
                    <label></label>
                    <div class="double-selector">
                        <label class="extended-label">{{ coreHMIBle?.value.ComponentName }}</label>
                        <mat-select required *ngIf="coreHMIBle?.value.Variants && coreHMIBle?.value.Variants.length!=0"
                            formControlName="coreHMIBleVariant" [ngClass]="{inactive: configurationBikeCount}"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of coreHMIBle?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="flex-row" *ngIf="coreHMIBleVariant?.invalid && coreHMIBleVariant?.touched">
                    <h5 class="error">
                        {{ coreHMIBle?.value.ComponentName }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>


                <div class="flex-row double-selector-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_Battery }}:</label>
                    <div class="double-selector">
                        <mat-select required *ngIf="batteryList && batteryList.length!=0" formControlName="battery"
                            [ngClass]="{inactive: configurationBikeCount}"
                            (selectionChange)="sameConfigChanged(); clearVariant('batteryVariant')">
                            <mat-option *ngFor="let component of getAvailableBatteries()" [value]="component"
                                [attr.tenant]="component.OEMName">{{
                                component.ComponentName }}
                            </mat-option>
                        </mat-select>

                        <mat-select required *ngIf="batteryList && batteryList.length!=0"
                            formControlName="batteryVariant" [ngClass]="{inactive: configurationBikeCount}"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of battery?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <label *ngIf="batteryList.length==0">{{
                        languageService.languageJSON.ConfigurationDetails_NoOption
                        }}</label>
                </div>

                <div class="flex-row"
                    *ngIf="battery?.invalid && battery?.touched || batteryVariant?.invalid && batteryVariant?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_Battery }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div formArrayName="batteryAddOns">
                    <div *ngFor="let batteryAddOn of batteryAddOns.controls; let index = index" [formGroupName]="index"
                        class="flex-row double-selector-row flex-addon-col">
                        <div class="flex-row">
                            <label>{{ languageService.languageJSON.ConfigurationDetails_Battery }} {{
                                languageService.languageJSON.Global_AddOn }}:</label>
                            <div class="double-selector">
                                <mat-select required *ngIf="batteryList && batteryList.length!=0"
                                    formControlName="battery" [ngClass]="{inactive: configurationBikeCount}"
                                    (selectionChange)="sameConfigChanged(); clearAddOnVariant(batteryAddOn, 'batteryVariant')">
                                    <mat-option *ngFor="let component of getAvailableBatteries(index)"
                                        [value]="component" [attr.tenant]="component.OEMName">{{
                                        component.ComponentName }}
                                    </mat-option>
                                </mat-select>

                                <mat-select required *ngIf="batteryList && batteryList.length!=0"
                                    formControlName="batteryVariant" [ngClass]="{inactive: configurationBikeCount}"
                                    (selectionChange)="sameConfigChanged()">
                                    <mat-option *ngFor="let variant of getBatteryAddOnBikes(batteryAddOn)"
                                        [value]="variant.Id" [attr.tenant]="variant.OEMName">{{
                                        variant.Name }}
                                    </mat-option>
                                </mat-select>

                                <button *ngIf="mode!='View'" type="button" class="delete-battery-icon" mat-icon-button
                                    color="warn" (click)="removeSelector(index)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                            <label *ngIf="batteryList.length==0">{{
                                languageService.languageJSON.ConfigurationDetails_NoOption
                                }}</label>
                        </div>
                        <div class="flex-row"
                            *ngIf="batteryAddOn.get('battery')?.invalid && batteryAddOn.get('battery')?.touched ||
                             batteryAddOn.get('batteryVariant')?.invalid && batteryAddOn.get('batteryVariant')?.touched">
                            <h5 class="error">
                                {{ languageService.languageJSON.ConfigurationDetails_Battery }} {{
                                languageService.languageJSON.Global_AddOn }}
                                {{ languageService.languageJSON.Form_Incomplete_Error }}
                            </h5>
                        </div>
                    </div>

                    <button *ngIf="configurationBikeCount==0 && mode!='View'" type="button" mat-icon-button
                        color="primary" class="add-battery-icon" (click)="addBatteryAddOnFormGroup()">
                        <mat-icon>add</mat-icon>{{ languageService.languageJSON.ConfigurationDetails_BatteryAddOn }}
                    </button>
                </div>

                <div class="flex-row double-selector-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_DriveUnit }}:</label>
                    <div class="double-selector">
                        <mat-select required *ngIf="driveUnitList && driveUnitList.length!=0"
                            formControlName="driveUnit" [ngClass]="{inactive: configurationBikeCount}"
                            (selectionChange)="sameConfigChanged(); clearVariant('driveUnitVariant')">
                            <mat-option *ngFor="let component of driveUnitList" [value]="component"
                                [attr.tenant]="component.OEMName">{{
                                component.ComponentName }}
                            </mat-option>
                        </mat-select>
                        <mat-select required *ngIf="driveUnitList && driveUnitList.length!=0"
                            formControlName="driveUnitVariant" [ngClass]="{inactive: configurationBikeCount}"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of driveUnit?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <label *ngIf="driveUnitList.length==0">{{ languageService.languageJSON.ConfigurationDetails_NoOption
                        }}</label>
                </div>
                <div class="flex-row"
                    *ngIf="driveUnit?.invalid && driveUnit?.touched || driveUnitVariant?.invalid && driveUnitVariant?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_DriveUnit }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row double-selector-row">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_RemoteLeft }}:</label>
                    <div class="double-selector">
                        <mat-select *ngIf="remoteLeftList && remoteLeftList.length!=0" formControlName="remoteLeft"
                            (selectionChange)="sameConfigChanged(); remoteLeftChanged(); clearVariant('remoteLeftVariant')">
                            <mat-option *ngFor="let component of remoteLeftList" [value]="component"
                                [attr.tenant]="component.OEMName">{{
                                component.ComponentName }}
                            </mat-option>
                        </mat-select>
                        <mat-select *ngIf="remoteLeftList && remoteLeftList.length!=0"
                            formControlName="remoteLeftVariant"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of remoteLeft?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <label *ngIf="remoteLeftList.length==0">{{
                        languageService.languageJSON.ConfigurationDetails_NoOption
                        }}</label>
                </div>

                <div class="flex-row"
                    *ngIf="remoteLeft?.value?.Id!='-1' && remoteLeftVariant?.invalid && remoteLeftVariant?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_RemoteLeft }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row double-selector-row">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_RemoteRight }}:</label>
                    <div class="double-selector">
                        <mat-select *ngIf="remoteRightList && remoteRightList.length!=0" formControlName="remoteRight"
                            (selectionChange)="sameConfigChanged(); remoteRightChanged(); clearVariant('remoteRightVariant')">
                            <mat-option *ngFor="let component of remoteRightList" [value]="component"
                                [attr.tenant]="component.OEMName">{{
                                component.ComponentName }}
                            </mat-option>
                        </mat-select>
                        <mat-select *ngIf="remoteRightList && remoteRightList.length!=0"
                            formControlName="remoteRightVariant"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of remoteRight?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <label *ngIf="remoteRightList.length==0">{{
                        languageService.languageJSON.ConfigurationDetails_NoOption
                        }}</label>
                </div>

                <div class="flex-row"
                    *ngIf="remoteRight?.value?.Id!='-1' && remoteRightVariant?.invalid && remoteRightVariant?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_RemoteRight }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row double-selector-row">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_Display }}:</label>
                    <div class="double-selector">
                        <mat-select *ngIf="displayList && displayList.length!=0" formControlName="display"
                            (selectionChange)="sameConfigChanged(); displayChanged(); clearVariant('displayVariant')">
                            <mat-option *ngFor="let component of displayList" [value]="component"
                                [attr.tenant]="component.OEMName">{{ component.ComponentName }}
                            </mat-option>
                        </mat-select>
                        <mat-select *ngIf="displayList && displayList.length!=0" formControlName="displayVariant"
                            (selectionChange)="sameConfigChanged()">
                            <mat-option *ngFor="let variant of display?.value.Variants" [value]="variant.Id"
                                [attr.tenant]="variant.OEMName">{{
                                variant.Name }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <label *ngIf="displayList.length==0">{{ languageService.languageJSON.ConfigurationDetails_NoOption
                        }}</label>
                </div>

                <div class="flex-row"
                    *ngIf="display?.value?.Id!='-1' && displayVariant?.invalid && displayVariant?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_Display }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="oe?.valid">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_WheelCircumference }}:</label>
                    <input type="number" required formControlName="wheelCircumference"
                        [ngClass]="{inactive: configurationBikeCount}">
                </div>

                <div class="flex-row" *ngIf="wheelCircumference?.invalid && wheelCircumference?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_WheelCircumference }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                        {{ languageService.languageJSON.ConfigurationDetails_WheelCircumferenceRequirement }}
                    </h5>
                </div>

                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_LightReservedArea }}:</label>
                    <input type="number" required formControlName="lightReservedArea"
                        [ngClass]="{inactive: configurationBikeCount}">
                </div>

                <div class="flex-row" *ngIf="lightReservedArea?.invalid && lightReservedArea?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_LightReservedArea }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                        {{ languageService.languageJSON.ConfigurationDetails_LightReservedAreaRequirement }}
                    </h5>
                </div>

                <div class="flex-row" [hidden]="display?.value.Id == -1 || display?.value == ''">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_DisplayOrientation }}:</label>
                    <mat-select *ngIf="displayOrientationOptionsList" formControlName="displayOrientation">
                        <mat-option *ngFor="let displayOrientation of displayOrientationOptionsList"
                            [value]="displayOrientation.id">
                            {{ displayOrientation.name }}</mat-option>
                    </mat-select>
                </div>

                <div class="flex-row" *ngIf="displayOrientation?.invalid && displayOrientation?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_DisplayOrientation }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row" [hidden]="display?.value.Id == -1 || display?.value == ''">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_BootLogoId }}:</label>
                    <mat-select formControlName="bootLogoId">
                        <mat-option *ngFor="let bootLogo of bootLogoIdList" [value]="bootLogo.id">{{
                            bootLogo.name}}</mat-option>
                    </mat-select>
                </div>

                <div class="flex-row" *ngIf="bootLogoId?.invalid && bootLogoId?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_BootLogoId }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <h5 class="red error bottom-error" *ngIf="sameConfigError">
        {{ languageService.languageJSON.ConfigurationDetails_SameConfigError }}
    </h5>

    <div class="form-section-send" *ngIf="!loading && mode!='View'">
        <button type="submit">{{ languageService.languageJSON.Global_Save}}</button>
        <button class="back-button" (click)="goBack()">{{ languageService.languageJSON.Global_Cancel}}</button>
    </div>
</form>